module.exports = __webpack_public_path__ + "img/IMG_8618_L_Foamcore.f7d51b42.jpg";